import React, { useState } from "react";
import { FiLink } from "react-icons/fi";
import { FaGithub } from "react-icons/fa";
import classNames from "classnames";
import Tags from "../../utils/Tags";

const Project = ({ item }) => {
  const { image, text, html_link, github, disc, tags, client } = item;
  const [showDesc, setShowDesc] = useState(3);

  const linkCss =
    "w-[2rem] h-[2rem] bg-black/50 rounded-full grid place-items-center hover:bg-black/20";
  return (
    <section
      className={`flex flex-col md:flex-row gap-5 group
      ${classNames({ "md:even:flex-row-reverse": !client })}
      `}>
      {/* image  */}
      <div className="flex-[1] overflow-hidden">
        <img
          className="w-full md:w-[20rem] h-[14rem] object-cover group-hover:scale-[1.2]
          transition-all duration-500"
          src={image}
          alt="project-img"
        />
      </div>
      {/* description  */}
      <div className="flex-[2]">
        <h2 className="text-xl">{text}</h2>
        {client && (
          <p className="text-sm text-darkText pt-1 capitalize">Client: {client}</p>
        )}
        <ul className="p-3 pl-7">
          {disc.slice(0, showDesc).map((item, i) => (
            <li key={i} className="list-disc font-light text-sm text-darkText">
              {item}
            </li>
          ))}
          {disc.length > showDesc && (
            <button
              onClick={() => setShowDesc(disc.length)}
              className="text-sm text-orange-700 hover:text-orange-500">
              show more...
            </button>
          )}
        </ul>
        {/* tags  */}
        <div className="flex items-center gap-2 flex-wrap">
          {tags.map((tag) => (
            <Tags key={tag} tag={tag} />
          ))}
        </div>
        {/* github and live links  */}
        <div
          className={`flex items-center gap-3 pt-4 justify-end
        ${classNames({ "even:justify-end": !client })}
        `}>
          {html_link && (
            <a
              className={linkCss}
              href={html_link}
              target="_blank"
              rel="noopener noreferrer">
              <FiLink />
            </a>
          )}
          {github && (
            <a
              className={linkCss}
              href={github}
              target="_blank"
              rel="noopener noreferrer">
              <FaGithub />
            </a>
          )}
        </div>
      </div>
    </section>
  );
};

export default Project;
